'use client';

import classNames from 'classnames';
import { ReactNode } from 'react';

type MessageRowProps = {
  children: ReactNode;
  orientation: 'left' | 'right';
};

/**
 * A layout component that positions messages according to their orientation (left/right)
 */
export const MessageRow = ({ orientation, children }: MessageRowProps) => {
  return (
    <div className={classNames('flex', orientation === 'left' ? '' : 'flex-row-reverse')}>
      {children}
      <span className="w-8" />
    </div>
  );
};